module.exports = __webpack_public_path__ + "static/img/login_oem.30e343d.png";


//////////////////
// WEBPACK FOOTER
// ./static/login/login_oem.png
// module id = ar5Y
// module chunks = 83